import React from "react";
import { createRoot } from "react-dom/client";
import VariantSelection from "../../components/variant-selection"; // Adjust the import path if necessary
import { getProducts } from "@/utils/product";
import { ProductDetails } from "@/sdk/types";

interface Variant {
  id: string; // This is the product ID/handle
  color: string;
}

interface VariantSelectionData {
  variants: Variant[];
}

// Sample data object for initial development
const sampleVariantSelectionData: VariantSelectionData = {
  variants: [
    {
      color: "red",
      id: "product-green-printed-a-line-kurta-24few10601-123041",
    }, // Replace with actual product IDs
    {
      color: "blue",
      id: "product-green-printed-a-line-kurta-24few10601-123041",
    },
    {
      color: "green",
      id: "product-green-printed-a-line-kurta-24few10601-123041",
    },
    {
      color: "yellow",
      id: "product-green-printed-a-line-kurta-24few10601-123041",
    },
  ],
};

// Handler function to find the element and render the React component
export default async function handleVariantSelection(element: HTMLElement) {
  // In a real scenario, you might fetch or get the data for the component here
  // For now, use the sample data
  const variantData = sampleVariantSelectionData;
  const details = await getProducts(variantData.variants.map((v) => v.id));
  const mapping = details.reduce(
    (acc, curr) => {
      acc[curr.id] = curr;
      return acc;
    },
    {} as Record<string, ProductDetails>,
  );
  const data = variantData.variants.map((v) => {
    const product = mapping[v.id];
    return {
      ...v,
      product,
    };
  });

  const root = createRoot(element); // Use createRoot for modern React
  root.render(
    <React.StrictMode>
      <VariantSelection variantData={data} />
    </React.StrictMode>,
  );
}
